<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu
      pageTitle="create_sales_return"
      :items="breadcrumbItems"
      :showHome="false"
    />

    <SalesReturnForm
      :form="form"
      :sale-search="saleSearch"
      :sale-search-results="saleSearchResults"
      :show-sale-results="showSaleResults"
      :items="items"
      :total-items="totalItems"
      :sub-total="subTotal"
      :grand-total="grandTotal"
      :is-submitting="isSubmitting"
      submit-label="sales_return_page.submit_sales_return"
      @update:saleSearch="handleSaleSearch"
      @focus-sale-search="searchSales('')"
      @select-sale="selectSale"
      @update:status="form.status = $event"
      @update:discount="form.discount = $event"
      @update:tax="form.tax = $event"
      @update:shipping="form.shipping = $event"
      @update:note="form.note = $event"
      @update-qty="updateItemQuantity"
      @remove-item="removeItem"
      @submit="submitSalesReturn"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import SalesReturnForm from "../../components/SalesReturn/CreateSalesReturn/SalesReturnForm.vue";
import { useSalesReturnForm } from "../../composables/useSalesReturn";

export default defineComponent({
  name: "CreateSalesReturnPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    SalesReturnForm,
    MainFooter,
  },
  setup() {
    return useSalesReturnForm();
  },
});
</script>
